import EmployeesSendMessagesModal from './sidebarComponents/EmployeesSendMessagesModal';
import CreateAccount from './sidebarComponents/CreateAccountModal';

export const getSidebarActions = () => [
  {
    component: CreateAccount,
    name: 'generate'
  }
  // {
  //   component: EmployeesSendMessagesModal,
  //   name: 'send'
  // }
];
